import {
  call,
  fork,
  put,
  select,
  takeLatest
} from 'redux-saga/effects';
import _ from 'lodash';
import loader from '../../../../util/loader/loader';
import {NORMALIZE_DATA} from '../../dataProvider/dataProvider';
import {
  SET_DATA,
  ADD_OFFER,
  UPDATE_FILTER,
  UPDATE_PRICE,
  UPDATE_SORT,
  dlOffersSelector,
  dlDisplayedOffersSelector,
  dlPriceStringSelector,
  dlFilterOptionSelected
} from './offers';
import {
  showGlobalSpinner,
  hideGlobalSpinner,
  errorPageByFlow
} from '../../common/common';
import {
  navigationRoutes,
  navigationSteps,
  buyFlowUrls
} from '../../navigation/navigationHelpers';
import {
  logCustomEvent
} from '../../dataLayer/dataLayer';
import {
  setAllOverlays,
  SET_OVERLAY_DATA,
  currentOverlaysSelector
} from '../../overlay/overlay';

// WATCHERS
export function* normalizeWatch() {
  yield takeLatest(NORMALIZE_DATA, normalizeWorker);
}

export function* addOfferWatch() {
  yield takeLatest(ADD_OFFER, addOfferWorker);
}

export function* filterOfferWatch() {
  yield takeLatest(UPDATE_FILTER, filterOfferWorker);
}

export function* priceOfferWatch() {
  yield takeLatest(UPDATE_PRICE, priceOfferWorker);
}

export function* sortOfferWatch() {
  yield takeLatest(UPDATE_SORT, sortOfferWorker);
}

// WORKERS
export function* normalizeWorker({key, data, meta}) {
  if (key !== 'offers') {
    return;
  }

  const defaultLobs = (_.get(data, 'defaultLobs')) ? _.get(data, 'defaultLobs') : [];

  yield put({
    type: SET_DATA,
    payload: {
      ...meta,
      flowType: data.flowType,
      offerData: data.offers,
      offerCount: data.offerCount,
      offerMinimumPrice: data.offerMinimumPrice,
      offerCardGigabitLearnMoreUrl: data.offerCardGigabitLearnMoreUrl,
      enableDynamicLobSelection: data.enableDynamicLobSelection,
      filterData: [
        ...defaultLobs,
        {
        name: "Monthly Price Range",
        legend: "Monthly Price Range",
        isSlider: true,
        options: [{
          name: "Price",
          step: 1,
          message: "Pricing does not include equipment, installation, taxes and fees, and other applicable charges.",
          id: "Price",
          label: "Monthly Price Range",
          ...data.offerFinderBuilder
        }]
      }],
      showOffersForLobs: data.showOffersForLobs,
      enableDefaultLobs: data.enableDefaultLobs
    }
  });
}

export function* addOfferWorker(action) {
  const errorPage = yield select(errorPageByFlow);
  const authEndpoint = navigationRoutes[navigationSteps.myPlan.MYPLAN].endpoints.validateAuth();
  const addOfferEndpoint = navigationRoutes[navigationSteps.myPlan.OFFERS].endpoints.addOfferToCart();
  const offersData = yield(select(dlOffersSelector));
  const currentOverlays = yield(select(currentOverlaysSelector));

  const data = {
    offerId: action.offer.offerId,
    force: action.force,
    overlayName: action.overlayName,
    offerLOBs: action.offer.offerLOBs,
    currentLOBs: action.currentLOBs
  };

  try {
    yield put(setAllOverlays(currentOverlays, false));
    yield put(showGlobalSpinner({hideContent: false}));
    yield call(loader.request, authEndpoint, {useGlobalSpinner: false});

    yield put({
      type: SET_OVERLAY_DATA,
      payload: {
        overlayData: data
      }
    });

    yield call(loader.request, addOfferEndpoint, {data, useGlobalSpinner: false, errorPage});

    const filterOptionSelected = yield (select(dlFilterOptionSelected));

    yield put(logCustomEvent({
      eventName: "Add to cart",
      eventAction: "add to cart",
      type: "click",
      eventMethod: "cart-Addition",
      product: [{
        productInfo: offersData.filter(offer => offer.productID === data.offerId)[0]
      }],
      page: {
        attributes: {
          filterOptionSelected: filterOptionSelected
        }
      }
    }));

    window.location.href = buyFlowUrls.CUSTOMIZE;

  } catch(e) {
    yield put(hideGlobalSpinner());
    //console.log(e);
  }
}

/*
    HACK: Relying on digitalData global
    I'm using UPDATE_FILTER action to prepopulate the user's default filters
    in pages/showOffers/showOffersFilterSagas.
    This would cause extra dataLayer events to be fired on page load.
    Instead, I'm searching the digitalData for the page load event before
    registering any filter click events.
    The cleaner implementation would be to fire a separate action to prepopulate
    and therefore this worker wouldn't have to diff between page load actions
    and user click actions
*/
export function* filterOfferWorker() {
  if (!_.isEmpty(window.digitalData) && window.digitalData.event) {
    const offersData = yield(select(dlDisplayedOffersSelector));
    const offerDataPageLoaded = _.findIndex(window.digitalData.event, {
      eventInfo: {
        eventName: "Offer Loaded",
        eventAction: "product view",
        type: "page load"
      }
    }) > -1;

    if (offerDataPageLoaded) {
      const filterOptionSelected = yield (select(dlFilterOptionSelected));

      yield put(logCustomEvent({
        eventName: "Offer Loaded",
        eventAction: "Filter changed",
        type: "click",
        eventMethod: "product-View",
        product: offersData.map((offer) => ({
          productInfo: {...offer}
        })),
        page: {
          attributes: {
            filterOptionSelected: filterOptionSelected
          }
        }
      }));
    }
  }
}

export function* priceOfferWorker() {
  const pricesStringRaw = yield(select(dlPriceStringSelector));

  yield put(logCustomEvent({
    eventName: "Button/link click",
    eventAction: pricesStringRaw,
    type: "click",
    eventMethod: "send-Event"
  }));
}

export function* sortOfferWorker() {
  const offersData = yield(select(dlDisplayedOffersSelector));
  const filterOptionSelected = yield (select(dlFilterOptionSelected));

  yield put(logCustomEvent({
    eventName: "Offer Loaded",
    eventAction: "Filter changed",
    type: "click",
    eventMethod: "product-View",
    product: offersData.map((offer) => ({
      productInfo: {...offer}
    })),
    page: {
      attributes: {
        filterOptionSelected: filterOptionSelected
      }
    }
  }));
}

export default function* offersSagas() {
  yield [
    fork(normalizeWatch),
    fork(addOfferWatch),
    fork(filterOfferWatch),
    fork(priceOfferWatch),
    fork(sortOfferWatch)
  ];
}



/** WEBPACK FOOTER **
 ** ./client/redux/modules/data/offers/offersSagas.js
 **/